const PARAGRAPH_CATEGORIES = (uuid: string, language: string) => `
  blockDataUUID(uuid: "${uuid}", language: "${language}") {
    ... on Categories {
      id
      categories {
				alias
				color
				name
				weight
			}
      categoryButton {
        title
        url
      }
      header
      iconBlock
      title
      type
      uuid
    }
  }
`;

export default PARAGRAPH_CATEGORIES;
